import {FieldComp} from "@sfs/components/FieldsBuilder/FieldComp/FieldComp";

// TODO divide this function : flattenInputFieldComponents / flattenAllFieldComponents
export const flattenFieldComponents = (
  components: Array<FieldComp>,
  keepOnlyInputs = true
): Array<FieldComp> => {
  if (!components) return [];

  const tree = components.map((comp) => {
    if (comp.input) {
      // If the component is a data input one, return it
      return comp;
    } else {
      // If the component is not an input, check if it has child components and return them.
      let branches: Array<FieldComp> = [];
      // Put together all child components present in the "components" argument, and then apply recursively the flattenFieldComponents function on it
      if (comp.components) branches = branches.concat(comp.components);
      return [comp, ...flattenFieldComponents(branches, keepOnlyInputs)];
    }
  });

  // Flatten the return value
  const flattenedComponents = tree.flat();
  return keepOnlyInputs ? flattenedComponents.filter((comp) => comp.input) : flattenedComponents;
};
